import { ItemList } from '../../orm'

class AdminUserForExportList extends ItemList {
    getEntityKey() {
      return "admin/user/data_for_export"
    }    
}

export const adminUserForExportList = new AdminUserForExportList("admin_user_data_for_export__default")
